import { toDateString } from '../../utils/dates';
import { omit } from 'lodash';

export const deserializeTest = ({ layoutId, values, intervalReport } = {}) => {
  return {
    layoutId,
    values: omit(values, ['ReportHours']),
    intervalReport,
  };
};

export const serializeTest = ({ LastCalibration, ...values }) => ({
  LastCalibration: LastCalibration instanceof Date ? toDateString(LastCalibration) : LastCalibration,
  ...values,
});

export const removeUnnecessaryValues = ({
  HasData,
  CallerTimeZoneId,
  MaxRadon,
  MinRadon,
  AverageRadon,
  IsnAttachmentId,
  IsnSyncDate,
  IsnSyncLastError,
  IsnSyncStatus,
  IsnTestId,
  IsnTestDisplayOid,
  IsnAttachmentDate,
  FloorPlanDisplayUrl,
  FloorPlanDisplayUrl2,
  FloorPlanFile,
  FloorPlanFile2,
  NextCalibration,
  ...values
}) => {
  return serializeTest(values);
};



// WEBPACK FOOTER //
// src/actions/dinamicTest/serializers.js